import React, { useState, useEffect } from "react";
import useFetchPost from "../hooks/useFetchPost";
import { toast, Bounce } from "react-toastify";
import SelectPicker from "rsuite/SelectPicker";
import CheckPicker from "rsuite/CheckPicker";
import { useLocation } from "react-router-dom";

const RaiseCustomInvoice = ({ data, setApiRun }) => {
  const location = useLocation();
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [amount, setAmount] = useState("");
  const [product, setProduct] = useState("");
  const [isDeal, setIsDeal] = useState(false);
  const [urlEndpoint, setUrlEndpoint] = useState("");

  const [errors, setErrors] = useState({});
  const [productList, setProductList] = useState([]);
  const [noProductError, setNoProductError] = useState("");

  const [customerId, setCustomerId] = useState(null);

  // Parse query parameters for url encrypt and dcrypt
  const searchParams = new URLSearchParams(location.search);
  const queryString = searchParams.get("debug");
  const debug = queryString == null || queryString == "false" ? false : true;

  const { fetchPostData } = useFetchPost();

  function isInteger(value) {
    // Regex to check if value is an integer (only digits, no spaces or special characters)
    const integerRegex = /^\d+$/;

    // Test the value against the regex
    return integerRegex.test(value);
  }

  const getCustomerId = async (customer_tattle_uuid) => {
		try {
			let requestBody = { customer_tattle_uuid }; 
	
			const response = await fetch(`${process.env.REACT_APP_CRM}/muvi6/get-customer-id`, {
				method: "POST",
				body: JSON.stringify(requestBody) // ✅ Ensure the payload is properly formatted
			});
	
			const responseData = await response.json();
	
			if (responseData.code === 200 && responseData.customer_id) {
				return responseData.customer_id;
			} else {
				console.error("No customer_id found for customer_tattle_uuid");
				return null;
			}
		} catch (error) {
			console.error("Error fetching customer_id:", error);
			return null;
		}
	};

  const getProduct = async (customer_id, data) => {
    console.log(customer_id, isInteger(customer_id));
    if (isInteger(customer_id)) {
      let requestBody = {
        app_token: customer_id,
        debug: true,
        // enterprise_api_gateway_url: data.enterprise_api_gateway_url, // "https://cms.idogic.com/",
        // server_id: data.server_id,
        studio_id: customer_id,
      };
      try {
        const responseData = await fetchPostData(
          `${process.env.REACT_APP_CRM}/muvi5/view-details`,
          requestBody
        );

        if (responseData && responseData.data[0]) {
          setNoProductError("");
          let customerType = responseData.data[0].customer_type;
          setProductList([
            {
              product_key: "49F37046FCD84520895FC18A4F5BFC8B",
              product_name: "Muvi One (Classic)",
              customer_type: customerType,
            },
          ]);
          setUrlEndpoint("/muvi5/raise-custom-invoice");
        } else {
          setNoProductError("No products are available in this account.");
        }
        //console.log(responseData.data[0].package, "Muvi 5 Data");
      } catch (error) {
        console.error("Error:", error);
      }
    } else {
      let requestBody = {
        app_token: customer_id,
        debug: true,
      };
      try {
        const responseData = await fetchPostData(
          `${process.env.REACT_APP_CRM}/muvi6/crm-data`,
          requestBody
        );
        if (responseData.code == 200) {
          const products = responseData.data.getCrmData.user_details.products;
          const productKeys =
            products !== null ? products.map((product) => product) : [];
          setProductList(productKeys);
          setNoProductError(
            products === null
              ? "No products are available in this account."
              : ""
          );
          setUrlEndpoint("/muvi6/raise-custom-invoice");
          // Extracting product_key and product_name based on customer_type
          // const filteredProducts = responseData.data.getCrmData.user_details.products
          // 	.filter((product) => product.customer_type === "Lead" || product.customer_type === "Customer")
          // 	.map((product) => ({
          // 		product_key: product.product_key,
          // 		product_name: product.product_name,
          // 	}));
        }
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  const handleClose = () => {
    const raiseCustomInvoiceModal =
      document.getElementById("raiseCustomInvoice");
    raiseCustomInvoiceModal.classList.remove("show");
    raiseCustomInvoiceModal.style.display = "none";
    setProduct("");
    setTitle("");
    setDescription("");
    setAmount("");
    setProductList([]);
  };

  //form validation with data set
  const handleTitleChange = (e) => {
    setTitle(e.target.value);
  };

  const handleDescriptionChange = (e) => {
    setDescription(e.target.value);
  };

  const handleAmountChange = (e) => {
    setAmount(e.target.value);
  };

  const handleSelectChange = (value) => {
    setProduct(value);
    //const foundProduct = productList.find((product) => product.product_key === value);
    // if (foundProduct) {
    // 	const customerType = foundProduct.customer_type;
    // 	if (customerType !== "Lead" && customerType !== "Customer") {
    // 		setNoProductError(`This product has a customer type of "${customerType}", which is not allowed.`);
    // 	}
    // } else {
    // 	setNoProductError("Product not found.");
    // }
  };

  // useEffect(() => {
  //   setAmount(
  //     data &&
  //       data.milestone_amount != null &&
  //       data.milestone_amount != undefined
  //       ? data.milestone_amount
  //       : 0
  //   );
  //   setIsDeal(
  //     data && data.isDeal != null && data.isDeal != undefined
  //       ? data.isDeal
  //       : false
  //   );
  //   data && data.isDeal ? getProduct(data && data.customer_id) : "";
  //   //getProduct("s66KuN8Y5T78h9vsfC0QCW9jzMh6CFU4");
  //   //console.log(data);
  // }, [data]);

  useEffect(() => {
		setAmount(
			data && data.milestone_amount != null && data.milestone_amount !== undefined 
				? data.milestone_amount 
				: 0
		);
	
		setIsDeal(
			data && data.isDeal != null && data.isDeal !== undefined 
				? data.isDeal 
				: false
		);
	
		if (data && data.isDeal) {
			getCustomerId(data.customer_tattle_uuid).then((id) => {
				if (id) {
					setCustomerId(id);
					getProduct(id, data);
				}
			});
		}
	}, [data]);

  // Function to handle data submission
  const handleSubmit = async () => {
    const errors = validateForm();
    if (Object.keys(errors).length === 0) {
      if (!customerId) { 
				toast.error("Unable to fetch customer_id for invoice.", { autoClose: 2000 });
				return;
			}
      // Submit form data
      const postData = {
        product_key: data && data.isDeal ? product : data.product_key,
        user_uuid: data && data.customer_user_uuid,
        // enterprise_api_gateway_url:
        // 	data && data.enterprise_api_gateway_url !== undefined ? data.enterprise_api_gateway_url : "",
        // server_id: data && data.server_id,
        customer_id: customerId,
        item_name: title,
        item_description: description,
        invoice_amount: amount,
        is_deal: data && data.isDeal ? data.isDeal : false,
        milestone_uuid: data && data.milestone_uuid ? data.milestone_uuid : "",
      };
      // console.log("Form Data", postData);
      // return;

      let crmStagingUrl = process.env.REACT_APP_CRM + urlEndpoint;
      let responseData;
      try {
        responseData = await fetchPostData(crmStagingUrl, postData);
        //console.log("Response:", responseData);
      } catch (error) {
        console.error("Error:", error);
      }
      if (responseData && responseData.code == 200) {
        setApiRun(true);
        // Reset form
        setProduct("");
        setTitle("");
        setDescription("");
        setAmount("");

        toast.success("Invoice Submitted Successfully.", {
          position: "top-right",
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
      } else {
        const errorMessage =
          responseData && responseData.message
            ? responseData.message
            : "An error occurred";

        toast.error(errorMessage, {
          position: "top-right",
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });

        console.warn("Something went wrong .in change to muvi ownership");
      }

      // Close the modal
      const raiseCustomInvoiceModal =
        document.getElementById("raiseCustomInvoice");
      raiseCustomInvoiceModal.classList.remove("show");
      raiseCustomInvoiceModal.style.display = "none";
      // Close the modal
      document
        .getElementById("raiseCustomInvoice")
        .dispatchEvent(new Event("click"));

      // Remove the backdrop
      document.getElementsByClassName("modal-backdrop")[0].remove();
    } else {
      setErrors(errors);
    }
  };
  const isValidProduct = (value) => {
    const foundProduct = productList.find(
      (product) => product.product_key === value
    );
    if (foundProduct) {
      const customerType = foundProduct.customer_type;
      if (customerType !== "Lead" && customerType !== "Customer") {
        setNoProductError(
          `This product has a customer type of "${customerType}", which is not allowed.`
        );
        return false;
      } else {
        return true;
      }
    }
  };
  const validateForm = () => {
    let errors = {};
    if (isDeal) {
      if (!product.trim()) {
        errors.product = "Product is required";
      } else if (!isValidProduct(product)) {
        errors.product = noProductError;
      }
    }

    if (!title.trim()) {
      errors.title = "Title is required";
    }
    if (!description.trim()) {
      errors.description = "Description is required";
    }
    if (!amount) {
      errors.amount = "Amount is required";
    } else if (isNaN(amount)) {
      errors.amount = "Amount must be a number";
    }
    return errors;
  };
  return (
    <div
      className="modal fade"
      id="raiseCustomInvoice"
      tabindex="-1"
      role="dialog"
      aria-labelledby="raiseCustomInvoiceLabel"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={handleClose}
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 className="modal-title" id="raiseCustomInvoiceLabel">
              Raise Invoice
            </h4>
          </div>
          <div className="modal-body">
            <form>
              {isDeal && (
                <div className="form-group">
                  <label for="recipient-name" className="control-label">
                    Product
                  </label>
                  <SelectPicker
                    data={productList.map((item) => {
                      return {
                        label: item.product_name,
                        value: item.product_key,
                      };
                    })}
                    name="product"
                    value={product}
                    onChange={handleSelectChange}
                    style={{
                      width: "100%",
                      zIndex: 1050,
                    }}
                    block={true}
                    searchable={false}
                    placeholder="Select Product"
                  />
                  <p className="text-danger" style={{ marginTop: "7px" }}>
                    {noProductError}
                  </p>
                  {errors.title && (
                    <p className="text-danger">{errors.product}</p>
                  )}
                </div>
              )}

              <div className="form-group">
                <label for="recipient-name" className="control-label">
                  Title
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="title"
                  value={title}
                  onChange={handleTitleChange}
                />

                {errors.title && (
                  <p className="text-danger" style={{ marginTop: "7px" }}>
                    {errors.title}
                  </p>
                )}
              </div>
              <div className="form-group">
                <label for="recipient-name" className="control-label">
                  Description
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="description"
                  value={description}
                  onChange={handleDescriptionChange}
                />
                {errors.description && (
                  <p className="text-danger" style={{ marginTop: "7px" }}>
                    {errors.description}
                  </p>
                )}
              </div>
              <div className="form-group">
                <label for="recipient-name" className="control-label">
                  Amount ($)
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="amount"
                  value={amount}
                  onChange={handleAmountChange}
                  onInput={(event) => {
                    event.target.value = event.target.value.replace(
                      /[^0-9]/g,
                      ""
                    );
                  }}
                  disabled={data && data.isDeal ? true : false}
                />
                {errors.amount && (
                  <p className="text-danger" style={{ marginTop: "7px" }}>
                    {errors.amount}
                  </p>
                )}
              </div>
            </form>
          </div>
          <div className="modal-footer">
            <span
              type="button"
              className="btn btn-blue"
              data-dismiss="modal"
              onClick={handleClose}
            >
              Close
            </span>
            <span
              type="button"
              className="btn btn-primary"
              // data-dismiss="modal"
              onClick={handleSubmit}
            >
              Submit
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RaiseCustomInvoice;



// WEBPACK FOOTER //
// ./src/components/crm/modals/RaiseCustomInvoice.jsx